import React, { useState } from 'react';
import { FieldArray } from 'formik';
import { GridColumnTitle, Label } from '../Form/';

import {
  TableHeader,
  TableColumn,
  InlineLabel,
  TableHead,
  TableRow,
  TableBody,
  Table,
  CustomField
} from './styles';
import Icon from "../Icon";


const ResponsiveTable = ({ columns = [], data = [], changeRemoveAttachments, changeShowAttachments, formikRef, onSortTable }) => {
  const [orderArrows, setOrderArrows] = useState({});

  const removeAttachment = value => {
    let elementToRemove, newAttachments;

    elementToRemove = data.find((att, index) => att.id === value.id);
    newAttachments = data.filter(attachment => attachment.id !== elementToRemove.id);

    changeRemoveAttachments(newAttachments);
  }

  function resetFormikOrderParams(formikRef) {
    columns.map(column => formikRef.setFieldValue(column.sortKey, null))
  }

  const renderRow = (row, indexData, isChildRow) => {
    return <TableRow key={indexData} style={row.highlightPayment === true ? {backgroundColor: '#BBBBBB'} : {}}>
      {columns.map((column, index) => {
        const keys = column.key?.split('|') || [];
        return <TableColumn key={index}>
          <InlineLabel>
            {column.title}
          </InlineLabel>
          {column.component && <CustomField>
            {column.component(row, indexData, isChildRow)}
          </CustomField>}
          {!column.component && <Label wordWrap fontSize={13} color={column.color ? column.color(row) : null}>
            {row[keys[0]] || row[keys[1]] || '-'}
          </Label>}
          {changeShowAttachments && (
            changeRemoveAttachments && column.key === 'remove' && <Label wordWrap fontSize={12}>
              <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeAttachment(row)} />
            </Label>)}
        </TableColumn>
      })}
    </TableRow>
  }

  return (
    <div style={{ marginLeft: 15, marginRight: 15 }}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column, index) =>
              <TableHeader 
                key={index} 
                minWidth={column.minWidth} 
                maxWidth={column.maxWidth} 
                paddingRight={column.paddingRight}
                notLastColumnAlign={column.notLastColumnAlign}
              >
                <GridColumnTitle
                  style={{ cursor: column.sortKey ? "pointer" : 'not-allowed', color: column.error && '#EB4C3D'}}
                  onMouseOut={() => setOrderArrows({ ...orderArrows, [column.sortKey]: false })}
                  onMouseOver={() => setOrderArrows({ ...orderArrows, [column.sortKey]: true })}
                  onClick={() => {
                    if (!column.sortKey) return;

                    const orderType = formikRef?.values[column.sortKey] == 2 ? 0 : (formikRef?.values[column.sortKey] || 0) + 1;
                    resetFormikOrderParams(formikRef);
                    formikRef.setFieldValue(column.sortKey, orderType);
                    onSortTable(column.sortKey, orderType);
                  }}
                >
                  {!changeShowAttachments && column.title === 'Remove' ? '' : column.title}
                  {" "}
                  {(!formikRef?.values || !formikRef?.values[column.sortKey] ? (<></>) : (<Icon name={formikRef?.values[column.sortKey] == 2 ? "arrowdown" : "arrowup"} />))}
                </GridColumnTitle>
              </TableHeader>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray
            name="tableData"
            render={() =>
              data.map((row, indexData) => (
                <>
                  {renderRow(row, indexData)}
                  {row.showChildRow && row.childrenData?.map((row, indexData) => renderRow(row, indexData, true))}
                </>
              ))
            }
          />
        </TableBody>
      </Table>
    </div>
  );
};


export default ResponsiveTable;
